import { render, staticRenderFns } from "./CouponUsed.vue?vue&type=template&id=5352b4c5&scoped=true&"
import script from "./CouponUsed.vue?vue&type=script&lang=js&"
export * from "./CouponUsed.vue?vue&type=script&lang=js&"
import style0 from "./CouponUsed.vue?vue&type=style&index=0&id=5352b4c5&lang=scss&scoped=true&"
import style1 from "./CouponUsed.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5352b4c5",
  null
  
)

export default component.exports